module.exports = __webpack_public_path__ + "static/article-image-a5583407ab3cc1422287af433adce938.jpg";